class RitsReactConsole {
	LOG_LEVEL = ["WARN", "ERROR", "FATAL"];
	WRITE_LOG = false;
	/**
	 *  Constructor
	 */
	constructor(LEVEL, WRITE = false) {
		this.LOG_LEVEL = LEVEL || this.LOG_LEVEL;
		this.WRITE_LOG = WRITE;
		if (process.env.NODE_ENV === "test") {
			this.LOG_LEVEL = ["WARN", "ERROR", "FATAL"];
		}
	}
	/**
	 *  Log debug message
	 * @param {*} message
	 * @param {*} params
	 */
	DEBUG = function (message, params = []) {
		if (this.LOG_LEVEL.includes("DEBUG")) {
			var msg = new Date() + ": DEBUG\n" + message + "\n---------";
			console.log(msg, params);
			this.writeLog(msg);
		}
	};
	/**
	 *  Log info message
	 * @param {*} message
	 * @param {*} params
	 */
	INFO = function (message, params = []) {
		if (this.LOG_LEVEL.includes("INFO")) {
			var msg = new Date() + ": INFO\n" + message + "\n---------";
			console.log(msg, params);
			this.writeLog(msg);
		}
	};
	/**
	 *  Log warn message
	 * @param {*} message
	 * @param {*} params
	 */
	WARN = function (message, params = []) {
		if (this.LOG_LEVEL.includes("WARN")) {
			var msg = new Date() + ": WARN\n" + message + "\n---------";
			console.log(msg, params);
			this.writeLog(msg);
		}
	};
	/**
	 *  Log error message
	 * @param {*} message
	 * @param {*} params
	 */
	ERROR = function (message, params = []) {
		if (this.LOG_LEVEL.includes("ERROR")) {
			var msg = new Date() + ": ERROR\n" + message + "\n---------";
			console.log(msg, params);
			this.writeLog(msg);
		}
	};
	/**
	 *  Log fatal message
	 * @param {*} message
	 * @param {*} params
	 */
	FATAL = function (message, params = []) {
		if (this.LOG_LEVEL.includes("FATAL")) {
			var msg = new Date() + ": FATAL\n" + message + "\n---------";
			console.log(msg, params);
			this.writeLog(msg);
		}
	};

	writeLog = function (message) {};

	createLogFile = function () {};
}
module.exports = RitsReactConsole;
